{"browse_shop":"Περιήγηση στο κατάστημα","go_to_shop":"Μετάβαση στο κατάστημα","no_orders_found":"Δεν βρέθηκαν παραγγελίες","title":"Παραγγελίες"}